module.exports = __webpack_public_path__ + "static/media/aadhaar-uidai.830eec43.svg";